import React, { useEffect, useMemo, useRef, useState } from "react";
import useDynamicCSS from "../../component/useDynamicCss";
import BetSlipContext from "../../context/BetSlipContext";
import { useContextSelector } from "use-context-selector";
import { inRange, isEmpty, startCase, upperCase } from "lodash";
import AuthContext from "../../context/AuthContext";
import { formatWithCommas } from "../../Utils/Toast";
import DialVelkie from "./DialVelkie";
const BetSlipVelkie = () => {
  const numberArray = [10, 100, 200, 500];
  const numberArrayCount = [1, 2, 3, 4, 5, 6, 7, 8, 9, 0, "00", "."];
  // let loader = useDynamicCSS(useMemo(() => ["/assets/css/betslip.css"], []));
  const user = useContextSelector(AuthContext, (ctx) => {
    return ctx.user;
  });
  const setBetSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setBetSlipObject;
  });
  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });
  const betLoader = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betLoader;
  });
  const profileData = useContextSelector(AuthContext, (ctx) => {
    return ctx.profileData;
  });

  const limit = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.limit;
  });
  const setShowBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setShowBetDialog;
  });
  const showBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.showBetDialog;
  });
  const setResetBetPosition = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setResetBetPosition;
  });
  const handelPlaceBetFair = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceBetFair;
  });
  const handelPlaceFancy = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceFancy;
  });
  const handelPlaceBookmaker = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceBookmaker;
  });
  const setLoginModal = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setLoginModal;
  });
  const handelPlaceSportBook = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceSportBook;
  });

  const handelPlaceToss = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.handelPlaceToss;
  });
  const [bidPriceDisabled, setBidPricDisabled] = useState(true);
  const [setting, setSetting] = useState(false);

  useEffect(() => {
    if (
      inRange(
        Number(betSlipObject?.bidPrice),
        limit?.minAmount || 1,
        limit?.maxAmount + 1 || 100
      )
    ) {
      setBidPricDisabled(false);
    } else {
      setBidPricDisabled(true);
    }
  }, [betSlipObject, limit]);
  const placeBet = () => {
    if (!isEmpty(user)) {
      if (
        betSlipObject?.playType == "betFaire" ||
        betSlipObject?.playType == "multi" ||
        betSlipObject?.playType == "home"
      ) {
        handelPlaceBetFair();
      } else if (betSlipObject?.playType == "fancy") {
        handelPlaceFancy();
      } else if (betSlipObject?.playType == "bookmaker") {
        handelPlaceBookmaker();
      } else if (betSlipObject?.playType == "sportBook") {
        handelPlaceSportBook();
      } else if (betSlipObject?.playType == "toss") {
        handelPlaceToss();
      }
    } else {
      setShowBetDialog(false);
      setLoginModal(true);
    }
  };

  const inputRef = useRef(null);
  const [activeInput, setActiveInput] = useState(null); // 1 or 2

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, [activeInput]);

  let OddsCondi = ["betFaire", "multi", "home"].includes(
    betSlipObject?.playType
  );
  return (
    <div>
      <div
        data-v-3c51d876=""
        class="absolute top-0 w-full h-full z-50"
        style={{ display: showBetDialog ? "block" : "none" }}
      ></div>
      <div
        style={{ display: showBetDialog ? "block" : "none" }}
        data-v-3c51d876
        className="bet-slip fixed z-50 container bottom-0 shadow-top rounded-t-xl slidein-enter-active"
        // bet-slip fixed z-50 container bottom-0 shadow-top rounded-t-xl
      >
        <div
          data-v-3c51d876
          className="bet-slip-content bg-white relative p-2 rounded-t-xl"
        >
          <header
            data-v-3c51d876
            className="bet-slip-title flex items-center font-bold mb-2"
          >
            {!["fancy", "sportBook", "toss"].includes(
              betSlipObject?.playType
            ) && (
              <span
                data-v-3c51d876
                className={`bet-tag  relative w-50px py-2 inline-block font-bold text-center text-13 rounded-full shrink-0 ${
                  ["lay", "No"].includes(betSlipObject?.betType)
                    ? "bg-lay lay"
                    : "bg-back back"
                } `}
              >
                {startCase(betSlipObject?.betType)}
              </span>
            )}
            <span
              data-v-3c51d876
              className="inline-block global-font-on-light text-18 align-text-bottom p-2 mr-6 break-all grow"
            >
              {betSlipObject?.teamName}
            </span>
            <div
              onClick={() => {
                setShowBetDialog(false);
                setResetBetPosition(true);
              }}
              data-v-3c51d876
              className="icon-close absolute right-2 mr-2 text-black text-base flex justify-center items-center cursor-pointer"
            />
          </header>

          <div data-v-3c51d876 className="flex">
            <section data-v-3c51d876 className="bet-amount bg-black-100">
              <dt data-v-3c51d876 className="title font-normal">
                Odds
              </dt>
              <dd data-v-3c51d876 className="input-box">
                <button
                  onClick={(e) => {
                    setBetSlipObject({
                      ...betSlipObject,
                      odds: Number(betSlipObject?.odds) - 0.01,
                    });
                  }}
                  disabled={!OddsCondi}
                  data-v-3c51d876
                  className="btn-normal p-3 font-bold rounded flex justify-center items-center disabled:bg-black-300 disabled:text-black-600 disabled:cursor-not-allowed"
                  name="minus"
                >
                  <i data-v-3c51d876 className="icon-minus" />
                </button>
                <span
                  data-v-3c51d876
                  name="odds"
                  className="input-field is-default"
                  value="1.67"
                >
                  {betSlipObject?.odds}
                </span>
                <button
                  onClick={(e) => {
                    setBetSlipObject({
                      ...betSlipObject,
                      odds: Number(betSlipObject?.odds) + 0.01,
                    });
                  }}
                  disabled={!OddsCondi}
                  data-v-3c51d876
                  className="btn-normal p-3 font-bold rounded flex justify-center items-center disabled:bg-black-300 disabled:text-black-600 disabled:cursor-not-allowed"
                  name="plus"
                >
                  <i data-v-3c51d876 className="icon-plus" />
                </button>
              </dd>
            </section>
            <section data-v-3c51d876 className="bet-amount ml-2 bg-black-100">
              <dt data-v-3c51d876 className="title bfont-normal">
                Stake
              </dt>
              <dd data-v-3c51d876 className="input-box">
                <button
                  onClick={(e) => {
                    if (betSlipObject?.bidPrice > 1) {
                      setBetSlipObject({
                        ...betSlipObject,
                        bidPrice: Number(betSlipObject?.bidPrice) - 1,
                      });
                    }
                  }}
                  data-v-3c51d876
                  className="btn-normal p-3 font-bold rounded flex justify-center items-center disabled:bg-black-300 disabled:text-black-600 disabled:cursor-not-allowed"
                  name="minus"
                  disabled={bidPriceDisabled}
                >
                  <i data-v-3c51d876 className="icon-minus text-black-900" />
                </button>
                <span
                  data-v-3c51d876
                  name="stake"
                  className="input-field is-focus"
                  value={Number(betSlipObject?.bidPrice)}
                >
                  {betSlipObject?.bidPrice}
                </span>
                <button
                  onClick={(e) => {
                    if (betSlipObject?.bidPrice > 0) {
                      setBetSlipObject({
                        ...betSlipObject,
                        bidPrice: Number(betSlipObject?.bidPrice) + 1,
                      });
                    }
                  }}
                  data-v-3c51d876
                  className="btn-normal p-3 font-bold rounded flex justify-center items-center disabled:bg-black-300 disabled:text-black-600 disabled:cursor-not-allowed"
                  name="plus"
                  disabled={bidPriceDisabled}
                >
                  <i data-v-3c51d876 className="icon-plus text-black-900" />
                </button>
              </dd>
            </section>
          </div>
          <div data-v-3c51d876 className="mb-2 flex">
            <div className="flex flex-1 justify-between">
              {(profileData?.stake?.length > 0
                ? profileData?.stake?.sort(function (a, b) {
                    return a - b;
                  })
                : numberArray
              )
                ?.slice(0, 4)
                ?.map((res) => {
                  return (
                    <button
                      onClick={() => {
                        if (activeInput == 1) {
                          setBetSlipObject({
                            ...betSlipObject,
                            odds: Number(res),
                          });
                        } else {
                          setBetSlipObject({
                            ...betSlipObject,
                            bidPrice: Number(res),
                          });
                        }
                      }}
                      className="btn-normal p-3 font-bold rounded flex justify-center items-center disabled:bg-black-300 disabled:text-black-600 disabled:cursor-not-allowed w-80px h-30px border-0"
                      type="button"
                      value={10}
                    >
                      +{res}
                    </button>
                  );
                })}

              <button
                onClick={() => setSetting(true)}
                className="btn-normal p-3 font-bold rounded flex justify-center items-center disabled:bg-black-300 disabled:text-black-600 disabled:cursor-not-allowed w-9 h-30px border-0 text-16"
                type="button"
              >
                <i className="icon-setting" />
              </button>
            </div>
          </div>
          <div data-v-3c51d876 className="flex">
            <div className="flex flex-1 flex-wrap">
              {numberArrayCount?.map((res) => {
                return (
                  <button
                    onClick={() =>
                      setBetSlipObject((prev) => {
                        return {
                          ...prev,
                          bidPrice:
                            Number(prev?.bidPrice) > 0
                              ? Number(String(prev?.bidPrice) + String(res))
                              : Number(res),
                        };
                      })
                    }
                    className="w-2/12 h-40px flex justify-center items-center font-normal border border-white bg-black-100 rounded disabled:bg-black-300 disabled:text-black-600 disabled:cursor-not-allowed"
                    type="button"
                  >
                    {res}
                  </button>
                );
              })}
            </div>
            <button
              onClick={() => {
                if (!betSlipObject?.bidPrice) return;
                const newValue = String(betSlipObject?.bidPrice).slice(0, -1);
                setBetSlipObject({
                  ...betSlipObject,
                  bidPrice: Number(newValue),
                });
              }}
              type="button"
              className="icon-backspace w-20 text-2xl font-bold border-solid border-l border-white rounded bg-black-100 disabled:bg-black-300 disabled:text-black-600 disabled:cursor-not-allowed"
            />
          </div>
          <div
            data-v-3c51d876
            className="info mt-1.5 flex justify-between items-center"
          >
            <div data-v-3c51d876></div>
            <div data-v-3c51d876 className="flex items-center text-black-500">
              <i data-v-3c51d876 className="mr-0.5 text-base icon-min-max" />
              <span data-v-3c51d876 className="mr-0.5 text-11">
                min/max
              </span>
              <mark
                data-v-3c51d876
                className="font-bold bg-white text-11 text-black-500"
              >
                {formatWithCommas(limit?.minAmount)}/
                {formatWithCommas(limit?.maxAmount)}
              </mark>
            </div>
          </div>
          <button
            data-v-3c51d876
            onClick={() => {
              placeBet();
            }}
            className="btn-normal p-3 font-bold rounded flex justify-center items-center disabled:bg-black-300 disabled:text-black-600 disabled:cursor-not-allowed w-full h-40px my-2"
            disabled={bidPriceDisabled}
            type="submit"
          >
            Place Bet
          </button>

          <div
            data-v-3c51d876
            className="loading absolute z-10 top-0 left-0 w-full h-full flex items-center justify-center bg-black-800 bg-opacity-87 rounded-t-xl"
            style={{
              display: betLoader ? "flex" : "none",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              data-v-3c51d876
              width={147}
              height={124}
              src={require("../../assets/images/loading-bet.webp")}
              alt
            />
          </div>
        </div>
      </div>{" "}
      {setting && <DialVelkie handleStackSetting={setSetting} />}
    </div>
  );
};

export default BetSlipVelkie;
